export var accountRoles = {
  USER: 'User',
  ADMIN: 'Admin',
  RELATIONSHIP_MANAGER: 'Relationship Manager',
  ANALYST: 'Analyst',
  SALES: 'Sales',
  SYSTEM: 'System',
  SCRAPER: 'Scraper'
};
export var companyUserRoles = {
  COMPANY_ADMIN: 'Company Admin',
  COMPANY_USER: 'Company User',
  COMPANY_PENDING: 'Company Pending'
};